import React from 'react';
import LoginRegistration from "./pages/LoginRegistration";
import ChatBot from "./pages/Chatbot";
import WebAnalyzer from "./pages/WebAnalyzer";
import SocialMediaAutomation from "./pages/SocialMediaAutomation";
import Calendar from "./pages/Calendar";
import BusinessDNA from "./pages/BusinessDNA";
import Profile from "./pages/Profile";
import AuthCallback from "./pages/AuthCallback";
import Gallery from "./pages/Gallery";
import Analytics from "./pages/Analytics";
import UGCVideos from "./pages/UGCVideos";
import ProtectedRoute from "./components/ProtectedRoute";

const appRoutes = [
  {
    path: "/",
    element: <LoginRegistration />,
  },
  {
    path: "/auth/callback",
    element: <AuthCallback />,
  },
  {
    path: "/webpage-analyzer",
    element: (
      <ProtectedRoute>
        <WebAnalyzer />
      </ProtectedRoute>
    ),
  },
  {
    path: "/adflyn-chatbot",
    element: (
      <ProtectedRoute>
        <ChatBot />
      </ProtectedRoute>
    ),
  },
  {
    path: "/social-media-automation",
    element: (
      <ProtectedRoute>
        <SocialMediaAutomation />
      </ProtectedRoute>
    ),
  },
  {
    path: "/gallery",
    element: (
      <ProtectedRoute>
        <Gallery />
      </ProtectedRoute>
    ),
  },
  {
    path: "/ugc-videos",
    element: (
      <ProtectedRoute>
        <UGCVideos />
      </ProtectedRoute>
    ),
  },
  {
    path: "/calendar",
    element: (
      <ProtectedRoute>
        <Calendar />
      </ProtectedRoute>
    ),
  },
  {
    path: "/analytics",
    element: (
      <ProtectedRoute>
        <Analytics />
      </ProtectedRoute>
    ),
  },
  {
    path: "/business-dna",
    element: (
      <ProtectedRoute>
        <BusinessDNA />
      </ProtectedRoute>
    ),
  },
  {
    path: "/profile",
    element: (
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    ),
  },
];

export default appRoutes;
